module.exports = __webpack_public_path__ + "media/9.ef3a9827.wav";